export default __webpack_public_path__ + "static/media/wp.c2f2dd04.svg";